import isEmpty from './isEmpty'
//---------------------
// get fatigue details
//---------------------
export function getFatigueDetailsForLevel(level) {
  const fatigue_details = {
    level: 'Fresh',
    threshold_percent: 0,
    adj_move: 0,
    adj_skills: 0,
    adj_sr: 0,
    adj_dex: 0,
  }

  if (level === 'Debilitated') {
    fatigue_details.level = 'Debilitated'
    fatigue_details.threshold_percent = 10
    fatigue_details.adj_move = -99
    fatigue_details.adj_skills = -50
    fatigue_details.adj_sr = -6
    fatigue_details.adj_dex = -10
  } else if (level === 'Exhausted') {
    fatigue_details.level = 'Exhausted'
    fatigue_details.threshold_percent = 20
    fatigue_details.adj_move = -99
    fatigue_details.adj_skills = -40
    fatigue_details.adj_sr = -4
    fatigue_details.adj_dex = -5
  } else if (level === 'Wearied') {
    fatigue_details.level = 'Wearied'
    fatigue_details.threshold_percent = 40
    fatigue_details.adj_move = -1
    fatigue_details.adj_skills = -30
    fatigue_details.adj_sr = -2
    fatigue_details.adj_dex = 0
  } else if (level === 'Tired') {
    fatigue_details.level = 'Tired'
    fatigue_details.threshold_percent = 60
    fatigue_details.adj_move = -1
    fatigue_details.adj_skills = -20
    fatigue_details.adj_sr = 0
    fatigue_details.adj_dex = 0
  } else if (level === 'Winded') {
    fatigue_details.level = 'Winded'
    fatigue_details.threshold_percent = 80
    fatigue_details.adj_move = 0
    fatigue_details.adj_skills = -10
    fatigue_details.adj_sr = 0
    fatigue_details.adj_dex = 0
  }

  return fatigue_details
}

export default function getFatigueDetails({ con_cur, con_wounds }) {
  console.log('---------------------------------')
  console.log('IN getFatigueDetails')
  console.log('con_cur = ' + con_cur)
  console.log('con_wounds = ' + con_wounds)

  if (isEmpty(con_cur) || isEmpty(con_wounds)) {
    console.alert('Missing con_cur or con_wounds for fatigue details calc')
  }

  const fatigue_details = getFatigueDetailsForLevel('Fresh')

  const con_tot = con_cur + con_wounds // i.e. ignore wounds for con total
  const con_per = Math.round((con_cur / con_tot) * 100) // i.e. remaining con as %age

  if (con_per <= 10) {
    return getFatigueDetailsForLevel('Debilitated')
  } else if (con_per <= 20) {
    return getFatigueDetailsForLevel('Exhausted')
  } else if (con_per <= 40) {
    return getFatigueDetailsForLevel('Wearied')
  } else if (con_per <= 60) {
    return getFatigueDetailsForLevel('Tired')
  } else if (con_per <= 80) {
    return getFatigueDetailsForLevel('Winded')
  }
  return fatigue_details
}
